import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from '@/App';
import { configureDependencies } from '@/di/container';
import '@/shared/i18n/config';
import '@/styles/globals.css';
import '@/styles/variables.css';

configureDependencies();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
